<template lang="pug"> 
  v-dialog(
    v-model='dialog'
    :persistent='persistent'
    :scrollable='scrollable'
    :disabled='disabled'
    :width='width'
    :max-width='maxWidth'
    :loading='loading'
  )
    slot(name="main")
      v-card(:color='color')
        v-card-title.toolbartab.white--text(primary-title)
          v-row(no-gutters align='center')
            v-col(cols=11, :class="{'text-center': titleCenter}")
              slot(name="title")
                h4 {{ title }}
              slot(name="subtitle")
                h5 {{ subtitle }}
            v-col(cols=1 align="end").align-self-start
              v-icon(
                dark
                @click='closeDialog()'
              ) mdi-close
        slot

</template>

<script>
export default { 
  props: {
    title:{ 
      type: [String],
      default: null,
    },
    subtitle:{ 
      type: [String],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String,Number],
      default: "auto",
    },
    maxWidth: {
      type: [String,Number],
      default: '600',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    }, 
    loading: {
      type: Boolean,
      default: false,
    }, 
    color: {
      type : String,
      default: null
    },
    titleCenter: {
      type: Boolean,
      default: false,
    }
  }, 
  data: () => ({ 
    dialog : false 
  }),
  watch: {
    value () {    
      this.dialog = this.value
    },

    dialog () {
      if(this.dialog !== this.value) {
        this.$emit('input',this.dialog)  
      } 
    }
  },
  methods : {
    closeDialog () {
      this.dialog = false
    }
  }
}
</script> 
